import React from 'react';
import { Box } from '@mui/material';
import { ConfirmationCancelDialogProps } from './ConfirmationCancelDialog.props';
import ConfirmationDialog from '../ConfirmationDialog';

const ConfirmationCancelDialog = ({ open, title, onClose, actions }: ConfirmationCancelDialogProps) => (
  <ConfirmationDialog open={open} title={title} onClose={onClose} actions={actions} maxWidth="xs">
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
      <p>Are you sure you want to continue?</p>
      <br />
      <p>All changes will be lost.</p>
    </Box>
  </ConfirmationDialog>
);

export default ConfirmationCancelDialog;
